module.exports = __webpack_public_path__ + "static/media/React.37fe8322.png";